import React from 'react';
import { Modal } from './modal';

import '../styles/dashboard.css';

export class AlertBox extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: true,
      parentCallback: this.props.parentCallback,
      defaultContent: this.props.children,
      fireRedirect: false
    }
  }

  handleModaltoggle = () => {
    this.setState({
      isOpen: !this.state.isOpen
    });

    this.props.handleAlertClose();
  };

  handleReload = () => {
    window.location.reload(true);
  }

  handleSessionDestroy = () => {
    if(window.confirm("Weet je zeker dat je een nieuw spel wilt starten?")){
      document.cookie = 'sessionID=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + document.domain;

      var getUrl = window.location;
      var baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[1];

      window.location.replace(baseUrl);
      // window.location.reload(true);
    }
  }

  getButtons = () => {
    if (this.props.errorHandle ===  true) {
      return (
        <div>
          <button style={{display: "inline-block", marginRight: "10px"}} className="alert button" onClick={this.handleReload}>Herlaad</button>
          <button style={{display: "inline-block"}} className="alert button" onClick={this.handleSessionDestroy}>Start een nieuw spel</button>
        </div>
      )
    } else {
      return (
        <button className="alert button" onClick={this.handleModaltoggle}>Sluiten</button>
      )
    }
  }

  render() {
    let width = "600px";
    if(document.getElementById("maintainRatio") !== null){
      let elem = document.getElementById("maintainRatio").getAttribute("style");
      elem = elem.split(";")

      for (var i = 0; i < elem.length; i++) {
        if(elem[i].startsWith("width")){
          let n = elem[i].split(" ");
          width = n[n.length -1];
        }
      }
    }

    return (
      <Modal maxWidth={width} show={this.state.isOpen}>
        <div className="dashboard">
          <header style={{backgroundColor: "#D21242"}}>
            <div className="dashboard--headerText">
              {this.props.title}
            </div>
          </header>
          <div className="content">
            <div className="alert wrap">
              <div className="alert notification">
                {this.props.text}
              </div>
              {this.getButtons()}
            </div>
          </div>
        </div>
      </Modal>
    )
  };
}



// WEBPACK FOOTER //
// ./src/components/alertBox.js